import useMutation from 'hooks/use-mutation';
import useCurrentSurface from 'routes/surface/hooks/use-current-surface';
import { useTranslation } from 'i18n';
import { revokeUserAccessOnSurfaceMutation } from 'graphql/user/mutations/revoke-user-access-on-surface';
import { fetchUsersWithAccessToSurfaceQuery } from 'graphql/user/queries/fetch-users-with-access-to-surface';
import { surfaceHierarchyQuery } from 'graphql/surface/queries/surface-hierarchy';
import toast from 'services/toast';
import { User } from 'graphql/types';

export default function useRevokeUserAccessOnSurface() {
  const { t } = useTranslation();
  const surface = useCurrentSurface();

  const [revokeUserAccessOnSurface] = useMutation(
    revokeUserAccessOnSurfaceMutation,
    {
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: fetchUsersWithAccessToSurfaceQuery,
          variables: { surface: surface?.id },
        },
        {
          query: surfaceHierarchyQuery,
          variables: { input: { surface: surface?.id } },
        },
      ],
    },
  );

  return function (user: User) {
    const input = {
      surface: surface?.id,
      user: user.id,
    };

    return revokeUserAccessOnSurface({ variables: { input } }).then(
      (response) => {
        if (response.isFailure) {
          return toast.error(response.getErrorMessage());
        }

        return toast.success(
          t('Successfully revoked access for {{fullName}}', {
            replace: { fullName: user.fullName },
          }),
        );
      },
    );
  };
}
